const PathsBasic = [
    'login',
    'refresh-token'
];

export default PathsBasic;